import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../../configuration/setup/store';
import { FleetState, Vehicle } from './fleet.types';

const initialState: FleetState = {
    vehicles: [],
};

const fleetSlice = createSlice({
    name: 'fleet',
    initialState,
    reducers: {
        storeVehicles: (state, action: PayloadAction<Vehicle[]>) => {
            state.vehicles = action.payload;
        },
    },
});

export const { storeVehicles } = fleetSlice.actions;

export const getVehicles = (state: RootState) => state.fleet.vehicles ?? 'NO_VEHICLES_AVAILABLE';

export default fleetSlice.reducer;
